let erudaLoader: Promise<typeof import("eruda")> | null = null;
const ERUDA_ENABLED =
  import.meta.env.DEV && import.meta.env.VITE_ENABLE_ERUDA === "true";

declare global {
  interface Window {
    __RECIPMON_TOGGLE_ERUDA__?: () => Promise<boolean>;
    __RECIPMON_ERUDA_VISIBLE__?: boolean;
  }
}

const loadEruda = async () => {
  if (!erudaLoader) {
    erudaLoader = import("eruda");
  }
  return erudaLoader;
};

export const initErudaDebug = async () => {
  if (!ERUDA_ENABLED) return false;

  const { default: eruda } = await loadEruda();

  if (!window.__RECIPMON_ERUDA_VISIBLE__) {
    eruda.init();
    eruda.show();
    window.__RECIPMON_ERUDA_VISIBLE__ = true;
  }

  window.__RECIPMON_TOGGLE_ERUDA__ = async () => {
    const { default: instance } = await loadEruda();
    const isVisible = Boolean(window.__RECIPMON_ERUDA_VISIBLE__);
    if (isVisible) {
      instance.hide();
      window.__RECIPMON_ERUDA_VISIBLE__ = false;
      return false;
    }
    instance.show();
    window.__RECIPMON_ERUDA_VISIBLE__ = true;
    return true;
  };

  return true;
};
